import {Space as MantineSpace} from '@mantine/core';

/**
 * Fixed-size spacer — design-layer pass-through over Mantine `Space`.
 * @registry Pass-through Mantine Space; import this instead of @mantine/core outside src/design.
 */
export const Space = MantineSpace;
